import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_modules, update_module, upload_module_icon } from './api';
import type { UpdateModuleInput } from './types';
import type { VendorModuleType } from '@/features/bookings/types';

const KEY = 'admin-modules';

export function use_modules() {
  return useQuery({ queryKey: [KEY], queryFn: fetch_modules });
}

export function use_update_module() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ module_type, input }: { module_type: VendorModuleType; input: UpdateModuleInput }) =>
      update_module(module_type, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function use_upload_module_icon() {
  return useMutation({ mutationFn: (file: File) => upload_module_icon(file) });
}
